<template>
  <div>
    <div class="container column sign-in--content container align-items-center justify-content-center hidden">
      <div class="sign-in--content__box animation-bottom">
        <div class="sign-in--content__box--header">
          <div class="sign-in--content__box--header__logo container align-items-center justify-content-center">
            <div class="jet" :class="{ animationJet : animaJet}">
              <img src="@/assets/img/logos/jet.svg" alt="Minds">
            </div>

            <img src="@/assets/img/logos/logo-login.svg" class="logo" alt="Minds">
          </div>
        </div>
        <div class="sign-in--content__box--content">
          <form role="form" class="full-width" @submit.prevent="validateBeforeSubmit(form)">
            <div class="sign-in--content__box--content--limit">
              <div class="block-input animation-fade animation-delay-02">
                  <div class="input-space input-space-special container align-items-center login__input">
                    <div class="icons">
                      <img
                        aria-hidden="true"
                        src="@/assets/img/boylogin.svg"
                        class
                        alt="star"
                        height="20"
                      >
                    </div>
                    <input
                      type="email"
                      name="email"
                      class="input input-big"
                      v-validate="'required|email'"
                      required
                      autofocus
                      placeholder="user@email.com"
                      v-model="form.email"
                      autocomplete="email"
                      :disabled="isLoading"
                    >
                  </div>
                  <div v-show="errors.has('email')" class="help-block" v-cloak>
                    <span>
                      <small>{{ errors.first('email') }}</small>
                    </span>
                  </div>
                </div>

                <div class="block-input animation-fade animation-delay-03">
                  <div class="input-space input-space-special container align-items-center login__input">
                    <div class="icons">
                      <img
                        aria-hidden="true"
                        src="@/assets/img/locklogin.svg"
                        class
                        alt="star"
                        height="22"
                      >
                    </div>
                    <input
                      type="password"
                      name="password"
                      class="input input-big"
                      v-validate="'required'"
                      required
                      autofocus
                      placeholder="password"
                      v-model="form.password"
                      autocomplete="password"
                      :disabled="isLoading"
                    >
                  </div>
                  <div v-show="errors.has('password')" class="help-block" v-cloak>
                    <span>
                      <small>{{ errors.first('password') }}</small>
                    </span>
                  </div>
                </div>
                <!-- <div class="block-input" :style="{ visibility: tried ? 'visible' : 'hidden' }">
                  <div
                    class="input-space input-space-special container align-items-center error-login"
                    style="background: rgb(209, 137, 148);"
                  >
                    <span>{{ message }}</span>
                  </div>
                </div> -->
              <div class="input-space-btns container align-items-center animation-fade animation-delay-05 btn-full">
                <button
                  type="submit"
                  name="button"
                  style="color: rgb(0, 115, 100); font-weight: 400; font-size: 16px!important;"
                  class="btn btn-rounded btn-blue-soft btn-full btn-shadow"
                  :disabled="isLoading"
                >ENTRAR<img src="@/assets/img/signin.svg" style="margin-left: 10px;" width="15px" alt=""></button>
                <i v-show="isLoading" class="fa fa-spinner fa-spin"></i>
              </div>
              <div class="input-space-btns container align-items-center animation-fade animation-delay-05 btn-full">
                <router-link style="letter-spacing: 1px; color: #760000; font-weight: 400;" class="btn btn-rounded btn-gradient-orange btn-full btn-shadow" :to="{ name: 'initialClass' }">
                  ASSISTIR AULA INICIAL
                </router-link>
              </div>

              <div style="justify-content: center; font-weight: 200;" class="input-space-bottom container wrap justify-content-between animation-fade animation-delay-05 padding-bottom-15">
                <router-link :to="{ name: 'recoverPassword' }">Recuperar senha</router-link>
              </div>
              <div class="block-input no-margin-bottom padding-bottom-10" :style="{ visibility: tried ? 'visible' : 'hidden' }">
                <div
                  class="input-space input-space-special container align-items-center error-login"
                  style="background: rgb(209, 137, 148);"
                >
                  <span>{{ message }}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="powered container align-items-center animation-bottom animation-delay-1">
        <span>Powered by</span>
        <a href="https://mindsidiomas.com.br/" target="_blank"><img class="by" src="@/assets/img/logos/minds-white.svg" width="75" alt="Minds"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import inputComponent from "@/components/input";

export default {
  data() {
    return {
      formError: null,
      form: {
        email: "",
        password: ""
      },
      loading: false,
      isLoading: false,
      checked: true,
      animaJet: false,
      tried: false,
      message: ""
    }
  },
  components: {
    inputComponent
  },
  methods: {
    animationJet() {
      this.animaJet = !this.animaJet;
    },
    validateBeforeSubmit(student) {
      if (this.tried) this.tried = false
      this.isLoading = true;
      this.$validator
        .validateAll()
        .then(async x => {
          await this.$store.dispatch('auth/login', student)
          await this.$delay(200)
          this.animationJet()
          this.isLoading = false
          await this.$delay(1500)
          this.animationJet()
        })
        .catch(error => {
          switch (error.code) {
            case 'auth/user-token-expired':
              this.message = 'Session Timeout'
              break
            case 'auth/too-many-requests':
              this.message = 'Try again later'
              break
            case 'auth/wrong-password':
              this.message = 'Incorrect Username or Password'
              break
            case 'auth/user-not-found':
              this.message = 'Incorrect Username or Password'
              break
            case 'user/not-found':
              this.message = 'Incorrect Username or Password'
              break
            case 'user/deactivated':
              this.message = 'User not active'
              break
            default:
              this.message = 'Login failed'
          }
          this.tried = true;
          this.isLoading = false;
        })
    },
    setUserDeactivated () {
      this.message = "Try again later";
      ths.tried = true
    }
  },
  mounted () {

  },
  beforeDestroy () {

  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/components/login";
</style>



// WEBPACK FOOTER //
// src/pages/auth/login.vue